import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type TireMakeSortDirection = "ASC" | "DESC";

export interface TireMakeListParams {
  page?: number;
  size?: number;
  sort?: TireMakeSortDirection;
  sortBy?: string;
}

export interface TireMakeRecord {
  id: string | number;
  name?: string;
  description?: string;
  active?: boolean | number | string;
  [key: string]: unknown;
}

export interface TireMakePayload {
  active: boolean;
  description?: string;
  name: string;
}

export interface TireMakeStatusPayload {
  id: string | number;
  active: boolean;
}

export interface TireMakePaginatedResponse {
  resources?: TireMakeRecord[];
  tireMakes?: TireMakeRecord[];
  data?: TireMakeRecord[];
  items?: TireMakeRecord[];
  content?: TireMakeRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) => url.replace("{id}", String(id));

export const getTireMakesList = (
  params: TireMakeListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: TireMakePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    }
  );

export const getTireMakeById = (id: string | number, language?: string) =>
  ApiService.get<{ response: TireMakeRecord }>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.GET, id),
    getLanguageHeaders(language)
  );

export const createTireMake = (payload: TireMakePayload, language?: string) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.ADD,
    payload,
    getLanguageHeaders(language)
  );

export const updateTireMake = (
  id: string | number,
  payload: TireMakePayload & { id: string | number },
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const updateTireMakeStatus = (
  id: string | number,
  payload: TireMakeStatusPayload,
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const deleteTireMake = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MAKES.DELETE, id),
    getLanguageHeaders(language)
  );
